<template>
  <div v-show="props.uploadTaskItemFiles.length > 0" class="upload-task">
    <div class="upload-task-wrapper" :style="{ height: uploadTaskHeight, maxHeight: uploadTaskHeight }">
      <v-scrollbar>
        <div v-for="(fileInfo, index) in props.uploadTaskItemFiles" :key="index">
          <UploadTaskItem :fileInfo="fileInfo" @remove="removeItems(index)" @preview="previewItems(index)" />
        </div>
      </v-scrollbar>
    </div>
    <div v-show="hasError" class="error-msg">{{ props.errMsg }}</div>
  </div>
</template>

<script setup>
  import UploadTaskItem from './UploadTaskItem.vue';
  import { computed } from 'vue';

  const props = defineProps({
    uploadTaskItemFiles: Array,
    errMsg: String,
  });

  const emits = defineEmits(['remove', 'preview']);
  const removeItems = (index) => {
    emits('removeItems', index);
  };

  const previewItems = (index) => {
    emits('previewItems', index);
  };

  const hasError = computed(() => {
    return props.errMsg !== '';
  });

  const uploadTaskHeight = computed(() => {
    return hasError.value ? '392px' : '416px';
  });

</script>

<style lang="scss" scoped>
.upload-task {
  height: 100%;
  .upload-task-wrapper {
    margin-top: 12px;
    overflow-y: auto;
  }
}

.error-msg {
  height: 24px;
  padding: 0 24px;
  color: var(--v-color-red);
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
}
</style>